/* eslint-disable */

import jsonp from "@/libs/api.request.js";
import { reactive, watch, ref, onMounted, createApp, nextTick } from "vue";
import Tabs from "@/class/Tabs";
import axios from "axios";
// import usePages from '@/composables/usePages'

type dataList = Array<any>;
type calendarInfo = {
  title: string;
  link: string;
  date: string;
};
type list = {
  data: calendarInfo[];
};

export function useCalendar() {
  let list: list = reactive({ data: [] });
  let value = ref(new Date().getTime());

  watch(value, (state, preState) => {
    if (preState != state) {
      fetchContent();
    }
  });

  onMounted(() => {
    fetchContent();
  });

  function getDate(dateString: string) {
    let interval = dateString.split(",");
    let stime = new Date(interval[0]);
    let etime = new Date(interval[1]);
    return `[${stime.getMonth() + 1}/${stime.getDate()} - ${
      etime.getMonth() + 1
    }/${etime.getDate()}]`;
  }

  function fetchContent() {
    axios("//static.web.sdo.com/mxd/pic/wiki/calendar.json?v=3", {}).then(
      (res: any) => {
        list.data = [];
        let a = [];
        for (const index in res.data) {
          let item = res.data[index];
          let interval = item.date.split(",");

          if (
            value.value >= new Date(interval[0]).getTime() &&
            value.value < new Date(interval[1]).getTime()
          ) {
            list.data.push(item);
          }
        }
      }
    );
  }

  return { list, value, fetchContent, getDate };
}
